import { render, staticRenderFns } from "./EditarApresentante.vue?vue&type=template&id=637813a3&scoped=true"
import script from "./EditarApresentante.vue?vue&type=script&lang=js"
export * from "./EditarApresentante.vue?vue&type=script&lang=js"
import style0 from "./EditarApresentante.vue?vue&type=style&index=0&id=637813a3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637813a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637813a3')) {
      api.createRecord('637813a3', component.options)
    } else {
      api.reload('637813a3', component.options)
    }
    module.hot.accept("./EditarApresentante.vue?vue&type=template&id=637813a3&scoped=true", function () {
      api.rerender('637813a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditarApresentante.vue"
export default component.exports